import React from "react";
import { ModeRendererProps } from "./types";

// VASARELY × LOUVRE POSTER CLUB: Cultural reprints turned digital op-icons
// Poster grids, museum palette, minimal borders
export function VasarelyLouvreposterclubMode({ brand }: ModeRendererProps) {
  return (
    <g>
      <defs>
        <linearGradient id="louvre-museum1" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor="#2C3E50" />
          <stop offset="50%" stopColor="#34495E" />
          <stop offset="100%" stopColor="#2C3E50" />
        </linearGradient>
        <linearGradient id="louvre-gold" x1="0" y1="0" x2="1" y2="0">
          <stop offset="0%" stopColor="#D4AF37" />
          <stop offset="50%" stopColor="#F4D03F" />
          <stop offset="100%" stopColor="#D4AF37" />
        </linearGradient>
      </defs>

      {/* Museum off-white background */}
      <rect x="0" y="0" width="794" height="1123" fill="#F8F6F0" />

      <g transform="translate(397 540)">
        {/* Poster grids (gallery wall) */}
        {[
          { x: -280, y: -350, w: 140, h: 200 },
          { x: -120, y: -350, w: 100, h: 150 },
          { x: 0, y: -350, w: 120, h: 180 },
          { x: 140, y: -350, w: 140, h: 200 },
          { x: -280, y: -120, w: 120, h: 180 },
          { x: -140, y: -120, w: 100, h: 150 },
          { x: 60, y: -120, w: 140, h: 200 },
          { x: -280, y: 90, w: 140, h: 200 },
          { x: -120, y: 90, w: 100, h: 150 },
          { x: 0, y: 90, w: 120, h: 180 },
          { x: 140, y: 90, w: 140, h: 200 },
        ].map((poster, i) => (
          <rect
            key={i}
            x={poster.x}
            y={poster.y}
            width={poster.w}
            height={poster.h}
            fill="url(#louvre-museum1)"
            stroke="#D4AF37"
            strokeWidth="2"
            opacity="0.15"
          />
        ))}

        {/* Minimal borders grid */}
        {Array.from({ length: 12 }).map((_, i) =>
          Array.from({ length: 16 }).map((_, j) => {
            const x = (i - 5.5) * 60;
            const y = (j - 7.5) * 65;
            
            return (
              <rect
                key={`${i}-${j}`}
                x={x - 28}
                y={y - 30}
                width="56"
                height="60"
                fill="none"
                stroke="#34495E"
                strokeWidth="1"
                opacity="0.2"
              />
            );
          })
        )}

        {/* Museum palette circles */}
        {Array.from({ length: 12 }).map((_, i) => {
          const r = 50 + i * 24;
          return (
            <circle
              key={i}
              cx="0"
              cy="0"
              r={r}
              fill="none"
              stroke={i % 2 === 0 ? "#2C3E50" : "#D4AF37"}
              strokeWidth="1.5"
              opacity={0.3 - i * 0.02}
            />
          );
        })}

        {/* French heritage in motion */}
        {Array.from({ length: 8 }).map((_, i) => {
          const angle = (i * Math.PI) / 4;
          return (
            <line
              key={i}
              x1="0"
              y1="0"
              x2={Math.cos(angle) * 280}
              y2={Math.sin(angle) * 280}
              stroke="#D4AF37"
              strokeWidth="1"
              opacity="0.2"
            />
          );
        })}

        {/* Central museum frame */}
        <rect x="-120" y="-140" width="240" height="280" fill="url(#louvre-museum1)" opacity="0.2" />
        <rect x="-120" y="-140" width="240" height="280" fill="none" stroke="url(#louvre-gold)" strokeWidth="3" />
        <rect x="-110" y="-130" width="220" height="260" fill="none" stroke="#2C3E50" strokeWidth="1" opacity="0.5" />

        {/* Optical icon center */}
        {Array.from({ length: 6 }).map((_, i) => {
          const size = 100 - i * 15;
          return (
            <rect
              key={i}
              x={-size / 2}
              y={-size / 2}
              width={size}
              height={size}
              fill="none"
              stroke={i % 2 === 0 ? "#2C3E50" : "#D4AF37"}
              strokeWidth="2"
              opacity={0.5 - i * 0.06}
            />
          );
        })}
      </g>

      {/* Cultural heritage */}
      <text x="397" y="1010" textAnchor="middle" fontFamily="serif" fontSize="10" fill="#2C3E50" letterSpacing="2">
        HERITAGE EN MOUVEMENT
      </text>
    </g>
  );
}
